import { Button } from '@chakra-ui/react'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { ContractTaskDto } from '../../../autogen/bff-api'
import { displayWrappedWithEllipsis } from '../../../common/formatting/displayWrappedWithEllipsis'
import { useIsV2 } from '../../../common/layout/v2/useIsV2'
import { urls } from '../../../urls'

interface Props {
    task: ContractTaskDto
    size?: 'sm' | 'md' | 'lg'
}

export const ContractTitle: React.FC<Props> = ({ task }) => {
    const navigate = useNavigate()
    const isV2 = useIsV2()

    // TODO: link to SharedContractDto if task is for a shared contract
    return (
        <Button
            variant="link"
            display="block"
            width="full"
            overflow="hidden"
            textOverflow="ellipsis"
            textAlign="start"
            size="sm"
            colorScheme={'blue'}
            onClick={() => {
                navigate(
                    isV2
                        ? urls.v2.contracts.view.go(task.contractId)
                        : urls.contracts.viewSingle.go(task.contractId)
                )
            }}
        >
            {displayWrappedWithEllipsis(task.contractTitle, 20)}
        </Button>
    )
}
